import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _moduleAssets = [];

let ModuleAssetStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return {remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _moduleAssets.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _moduleAssets.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByModule: function(moduleId) {
        return _moduleAssets.filter(function(e) { return e !== undefined && e.moduleId == moduleId; });
    },
    add: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.moduleId) {
            let index = _moduleAssets.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.moduleId == entity.moduleId; });
            if (0 <= index) {
                _moduleAssets[index] = entity;
            } else {
                _moduleAssets.push(entity);
            }
        }
    },
    remove: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.moduleId) {
            let index = _moduleAssets.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.moduleId == entity.moduleId; });
            if (0 <= index) {
                if (!!entity.deleted) {
                    delete _moduleAssets[index];
                } else {
                    _moduleAssets[index].loading = undefined;
                }
            }
        }
    },

});

ModuleAssetStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.MODULE_ASSET_LIST:
            action.data.forEach(ModuleAssetStore.add);
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_LIST_ERROR:
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_INFO:
            ModuleAssetStore.add(action.data);
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_INFO_ERROR:
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_ADD:
        case ActionTypes.MODULE_ASSET_UPDATE:
            ModuleAssetStore.add(action.data);
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_ADD_ERROR:
        case ActionTypes.MODULE_ASSET_UPDATE_ERROR:
            // trigger error message
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_DELETE:
            ModuleAssetStore.remove(action.data);
            ModuleAssetStore.emitChange();
            break;

        case ActionTypes.MODULE_ASSET_DELETE_ERROR:
            ModuleAssetStore.emitChange();
            break;

        default:
            break;

    }

});

export default ModuleAssetStore;


